<template>
    <ClModal
        v-model="showModal"
        maxWidth="350px"
    >
        <v-card>
            <v-card-title class="primary white--text">
                <h3>Attach Image</h3>
                <v-spacer/>
                <v-btn
                    icon
                    @click="closeModal()"
                >
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <BaseImageInput
                    ref="baseImage"
                    placeholder="Upload Image"
                    :bgImageData="image"
                    @savePicture="( data ) => savePicture( data )"
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <!-- Clear -->
                <ClButton
                    :disabled="!hasImage"
                    type="secondary"
                    :rounded="false"
                    @click="clearPicture()"
                >
                    Clear
                </ClButton>
                <!-- Save -->
                <ClButton
                    :disabled="!hasImage"
                    :rounded="false"
                    @click="updatePicture()"
                >
                    Save
                </ClButton>
            </v-card-actions>
        </v-card>
    </ClModal>
</template>

<script>
import BaseImageInput from './base/BaseImageInput';

export default {
    name: 'ModalPictureSelection',
    components: {
        BaseImageInput,
    },
    props: {
        image: {
            type: Array,
            required: false,
            default: null,
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            bgImage: [],
            hash: [],
        };
    },
    computed: {
        showModal: {
            get() {
                return this.value;
            },
            set( value ) {
                this.$emit( 'input', value );
            },
        },
        /** @returns { Boolean } */
        hasImage() {
            return this.bgImage.length > 0;
        },
    },
    watch: {
        showModal() {
            if ( this.showModal ) {
                this.bgImage = this.image;
                this.$nextTick( () => {
                    this.$refs.baseImage.setImageData();
                } );
            } else {
                this.clearLocalImageData();
            }
        },
    },
    mounted() {
        this.bgImage = this.image;
    },
    methods: {
        closeModal() {
            this.showModal = false;
        },
        clearLocalImageData() {
            this.hash = [];
            this.bgImage = [];
            this.$refs.baseImage.clearImageData();
        },
        savePicture( data ) {
            this.bgImage = data.image;
            this.hash = data.hash;
        },
        updatePicture() {
            this.$emit( 'updatePicture', { image: this.bgImage, hash: this.hash } );
        },
        clearPicture() {
            this.clearLocalImageData();
            this.$emit( 'clearPicture' );
        },
    },
};
</script>

<style scoped lang="scss">
.v-dialog {
    >.v-card {
        >.v-card__text {
            margin-top: 2rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
        >.v-card__actions {
            padding-bottom: 1rem;
        }
    }
}
</style>
